var React = require('react');

function Right (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 13L10.5 8L5.5 3","stroke":"currentColor"}));
}

Right.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Right;

Right.default = Right;
